import { defineStore } from 'pinia';

export const useGlobalStore = defineStore('global', {
  state: () => ({
    state: null,
    landingConfig: null,
  }),
  actions: {
    async fetchState(clientId) {
      try {
        const theme = document.documentElement.getAttribute('data-theme');
        if (theme !== 'TMH' || !clientId) {
          this.state = 'OPEN';
          return;
        }
        const res = await fetch(
          `/api/proxy?route=patient-status&clientId=${clientId}`
        );
        const data = await res.json();
        if (data.status === 'PENDING') {
          this.state = 'OPEN';
        } else if (data.status === 'COMPLETED') {
          this.state = 'CLOSED';
        } else {
          this.state = 'NOT_AVAILABLE';
        }
      } catch (e) {
        console.error('State fetch failed:', e);
        this.state = 'NOT_AVAILABLE';
      }
    },
    async checkQuestionnaireStatus(clientId, token, type, professionalId) {
      const theme = document.documentElement.getAttribute('data-theme');
      if (
        (theme !== 'default' && theme !== 'VIBOOD' && theme !== 'PSYPILOT') ||
        !clientId
      ) {
        return { shouldRedirect: false };
      }

      try {
        const env = new URLSearchParams(window.location.search).get('env');
        let url = `/api/proxy?route=questionnaire-status&clientId=${clientId}`;
        if (token) {
          url += `&token=${token}`;
        }
        if (type) {
          url += `&type=${type}`;
        }
        if (professionalId) {
          url += `&professionalId=${professionalId}`;
        }
        if (env) {
          url += `&env=${env}`;
        }
        const res = await fetch(url);
        const data = await res.json();
        if (data.status === 'unavailable') {
          this.state = 'NOT_AVAILABLE';
          return {
            shouldRedirect: true,
            clientId,
            token,
            type,
            professionalId,
          };
        } else if (data.status === 'completed') {
          this.state = 'CLOSED';
          return {
            shouldRedirect: true,
            clientId,
            token,
            type,
            professionalId,
          };
        }
        return { shouldRedirect: false };
      } catch (e) {
        console.error('Questionnaire status check failed:', e);
        this.state = 'NOT_AVAILABLE';
        return { shouldRedirect: true, clientId, token, type };
      }
    },
    async getLandingConfig(clinicId) {
      const theme = document.documentElement.getAttribute('data-theme');
      if (theme !== 'default' && theme !== 'PSYPILOT') {
        return null;
      }
      if (!clinicId) {
        return null;
      }
      try {
        const env = new URLSearchParams(window.location.search).get('env');
        let url = `/api/proxy?route=landingConfig&clinicId=${clinicId}`;
        if (env) {
          url += `&env=${env}`;
        }
        const res = await fetch(url);
        const data = await res.json();
        this.landingConfig = data;
        return data;
      } catch (error) {
        return null;
      }
    },
    closeState() {
      this.state = 'CLOSED';
    },
  },
});
